import { WorkOrder as RltWorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import { useEffect } from "react";
import { useRltTreatmentShowQuery } from "@/services/backend/rlt/treatments/api/treatment-api";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { formatDate } from "@/shared/lib/utilities/date";
import {
  ConnectInvoiceExportDialog,
  useSetConnectInvoiceExportText,
} from "@/services/backend/connect/components/connect-invoice-export";
import {
  useRltPricing,
  useRltSegmentPrices,
} from "@/services/backend/connect/components/string-builder-helpers-rlt";
import {
  useAttachmentsString,
  useServiceKindTitle,
  useWorkOrderReference,
} from "@/services/backend/connect/components/string-builder-helpers";

export function ConnectInvoiceExportDialogRlt({
  workOrder,
}: {
  workOrder: RltWorkOrder;
}) {
  return (
    <ConnectInvoiceExportDialog>
      <RltInvoiceExport workOrder={workOrder} />
    </ConnectInvoiceExportDialog>
  );
}

export function RltInvoiceExport({ workOrder }: { workOrder: RltWorkOrder }) {
  const setText = useSetConnectInvoiceExportText();
  const { data: treatment } = useRltTreatmentShowQuery({
    id: workOrder.treatmentId,
  });

  const title = useServiceKindTitle(GSMServiceKind.RLT);
  const workOrderReference = useWorkOrderReference(
    workOrder,
    GSMServiceKind.RLT,
  );
  const segmentPrices = useRltSegmentPrices(treatment);
  const pricing = useRltPricing(workOrder.pricingId);
  const attachments = useAttachmentsString();

  const { beginDate } = workOrder;

  useEffect(() => {
    setText(
      [
        title,
        "",
        workOrderReference,
        `Leistungszeitpunkt: ${formatDate(beginDate)}`,
        "",
        segmentPrices,
        pricing,
        "",
        attachments,
      ].join("\n"),
    );
  }, [
    setText,
    title,
    workOrderReference,
    beginDate,
    segmentPrices,
    pricing,
    attachments,
  ]);

  return null;
}
